import type { ReactNode } from 'react';
import { HubBackLink } from '@/components/hub/HubBackLink';

interface CourseHeroProps {
  title: string;
  backUrl: string;
  backLabel?: string;
  description?: string | null;
  meta?: ReactNode;
  aside?: ReactNode;
  progressPercent?: number;
  showProgress?: boolean;
}

export function CourseHero({
  title,
  backUrl,
  backLabel = 'Volver',
  description,
  meta,
  aside,
  progressPercent = 0,
  showProgress = false,
}: CourseHeroProps) {
  const progress = Math.min(100, Math.max(0, progressPercent));
  const rounded = Math.round(progress);

  return (
    <header className="lms-course-hero">
      <div className="lms-site-admin-hub-container">
        <div className="lms-course-hero__row">
          <div className="lms-course-hero__copy">
            <div className="flex items-start gap-4">
              <HubBackLink to={backUrl} label={backLabel} />
              <div className="min-w-0">
                <h1 className="lms-course-hero__title text-3xl font-semibold text-dash-primary md:text-4xl">{title}</h1>
                {description && <p className="lms-course-hero__lead">{description}</p>}
                {meta && <div className="lms-course-hero__meta">{meta}</div>}
              </div>
            </div>
          </div>

          {aside ? (
            <div className="lms-course-hero__progress-wrap">
              <div className="lms-course-hero__progress-divider" aria-hidden="true" />
              <div className="lms-course-hero__aside">{aside}</div>
            </div>
          ) : showProgress ? (
            <div className="lms-course-hero__progress-wrap">
              <div className="lms-course-hero__progress-divider" aria-hidden="true" />
              <div className="lms-course-hero__progress" role="group" aria-label="Tu progreso en el curso">
                <div className="lms-course-hero__progress-head">
                  <span className="lms-course-hero__progress-label">Tu progreso</span>
                  <span className="lms-course-hero__progress-value">{rounded}%</span>
                </div>
                <div
                  className="lms-course-hero__progress-track"
                  role="progressbar"
                  aria-valuenow={rounded}
                  aria-valuemin={0}
                  aria-valuemax={100}
                >
                  <div className="lms-course-hero__progress-fill" style={{ width: `${progress}%` }} />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}
